<template>
<section>
  <div class="group-nav">
    <div class="flex">
      <b class="flex-item flex-1 flex-center" @click="$router.push({ path: '/' })">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
      </b>
      <div class="flex-item flex-11 group-nav-title">{{ category.name }}</div>
      <span class="flex-item flex-1"></span>
    </div>
    <div class="group-nav-nav">
      <div class="group-nav-nav-item"
        v-for="group in category.items"
        :key="group"
        :class="isActive(group.id) ? 'is-active' : ''"
        >
        <router-link
        :to="'#' + group.id"
        tag="p">{{ group.name }}
        </router-link>
      </div>
    </div>
  </div>
  <div id="group-wrapper">
    <div :id="group.id" v-observe-visibility="visibilityChanged" class="group" v-for="group in category.items" :key="group">
      <div class="group-header">
        <h1>{{ group.name }}</h1>
      </div>
      <div class="menu-wrapper">
        <div class="menu" v-for="item in group.items" :key="item.item_id">
          <div class="menu-image">
              <img :src="item.picture" alt="">
          </div>
          <div class="menu-content">
            <h2>{{ item.name }}</h2>
            <p>{{ item.detail }}</p>
            <p class="text-bold">{{ parseFloat(item.price).toFixed(2) }} ฿</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="group-button">
    <button class="button" @click="$router.push({ path: '/' })">Back to Main</button>
  </div>
  <the-footer />
</section>
</template>

<script>
import TheFooter from '@/components/TheFooter'
export default {
  components: {
    TheFooter
  },
  data () {
    return {
      activigGroup: ''
    }
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        this.setCurrentGroup(entry.target.id)
      }
    },
    setCurrentGroup (id) {
      this.activigGroup = id
    },
    isActive (id) {
      return this.activigGroup === id
    }
  },
  computed: {
    category () {
      const cateId = this.$route.params.categoryId
      return this.$store.getters.getCategoryById(cateId)[0]
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-wrapper {
  max-width: 100%;
  grid-template-rows: repeat(12 auto);
  padding: 0;
  margin: 0;
}

#group-wrapper {
  margin-top: var(--nav-height);
}

.menu {
  padding: 0;
  margin: 0;
}

.menu .menu-image {
}

.menu .menu-image img {
  max-width: 100%;
}

/* Override */
.menu-wrapper {
  color: white;
  text-align: center;
}

.menu-content {
  font-weight: 200;
  line-height: 2.5em;
  margin: 3em 0em;
  color: black;
}

.menu-content h2 {
  font-size: 2em;
  font-weight: 200;
}

.text-bold {
  font-weight: 500;
  font-size: 1.5em;
  letter-spacing: .2em;
}

.group {
  padding-top:15px;
  margin-bottom:120px;
  box-shadow:burlywood;
}

.group-header {
  padding:0 1em;
  border-bottom: solid black 2px;
  border-top: solid black 2px;
}

.group-nav {
  position: fixed;
  padding-top:0.5em;
  background: white;
  min-height: var(--nav-height);
  top: 0;
  left: 0;
}

.group-nav {
  display: grid;
  grid-template-rows: repeat(12, 1fr);
  grid-template-rows: auto auto;
  width: 100%;
}

.group-nav-title {
  text-transform: uppercase;
  font-size: 2em;
  text-align: center;
}

.group-nav-nav {
  display: flex;
  overflow: scroll;
  background: white;
}

/* this will hide the scrollbar in webkit based browsers - safari, chrome, etc */
.group-nav-nav::-webkit-scrollbar {
  width: 0 !important;
  display: none;
}

.group-nav-nav-item {
  background: white;
  word-wrap: none;
  min-width: 200px;
}

.group-nav-nav-item > p {
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -o-pre-wrap; /* Opera */
  white-space: pre-wrap; /* Chrome */
  word-wrap: break-word; /* IE */
  width: 100%;
  text-align: center;
}

.is-active {
  border-bottom: solid black 2px;
}

#group-button {
  text-align: center;
  padding: .5em;
}

#group-button > .button {
  padding: 1em;
  width: 170px;
  background: none;
  cursor: pointer;
}
</style>
